module.exports = __webpack_public_path__ + "img/C04HorsemanS_ua.1f937eca.webp";